import styled from 'styled-components';
import {
  Fontw35s24h32,
  Fontw4s10h16,
  Fontw4s12h12,
  Fontw4s12h16,
  Fontw4s12h18,
  Fontw4s14h20,
  Fontw4s14h21,
  Fontw4s16h24,
  Fontw4s24h32,
  Fontw4s30h36,
  Fontw4s32h40,
  Fontw4s40h44,
  Fontw5s12h18,
  Fontw5s14h20,
  Fontw5s16h24,
  Fontw5s12h12,
  Fontw4s18h28,
  Fontw5s18h28,
  defaultFont,
  Fontw4s22h30,
  Fontw4s14h16,
  Fontw5s14h16,
} from 'styles/commonCss';

import type { JSX } from 'react';
import { mqSmallMin, mqLargeMin } from 'styled/tools/media-queries';

// this && is here becasue something in the main css is overriding the font size
export const PFontw35s24h32 = styled.p`
  && {
    ${Fontw35s24h32}
  }
`;

export const PFontw3s40h40 = styled.p`
  ${defaultFont}
  font-weight: 300;
  font-size: 40px;
  line-height: 40px;
`;

export const PFontw4s10h16 = styled.p`
  ${Fontw4s10h16}
`;

export const PFontw4s12h12 = styled.p`
  ${Fontw4s12h12}
`;

export const PFontw4s12h16 = styled.p`
  ${Fontw4s12h16}
  a {
    ${Fontw4s12h16}
  }
`;

export const PFontw4s12h18 = styled.p`
  ${Fontw4s12h18}
`;

export const PFontw4s14h20 = styled.p`
  ${Fontw4s14h20}
`;

export const PFontw4s14h21 = styled.p`
  ${Fontw4s14h21}
`;

export const PFontw4s16h24 = styled.p`
  ${Fontw4s16h24}
`;

export const PFontw4s18h28 = styled.p`
  ${Fontw4s18h28}
`;

export const PFontw4s22h30 = styled.p`
  ${Fontw4s22h30}
`;

export const PFontw4s24h32 = styled.p`
  ${Fontw4s24h32}
`;

export const PFontw4s30h36 = styled.p`
  ${Fontw4s30h36}
`;

export const PFontw4s32h40 = styled.p`
  ${Fontw4s32h40}
`;

export const PFontw4s40h44 = styled.p`
  ${Fontw4s40h44}
`;

export const PFontw5s12h12 = styled.p`
  ${Fontw5s12h12}
`;

export const PFontw5s12h18 = styled.p`
  ${Fontw5s12h18}
`;

export const PFontw5s14h20 = styled.p`
  ${Fontw5s14h20}
`;

export const PFontw5s16h18 = styled.p`
  ${defaultFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
`;

export const PFontw5s18h28 = styled.p`
  ${Fontw5s18h28}
`;

export const PFontw5s16h24 = styled.p`
  ${Fontw5s16h24}
`;

export const PFontw5s14h16 = styled.p`
  ${Fontw5s14h16}
`;

export const PFontw4s14h16 = styled.p`
  ${Fontw4s14h16}
`;

export const DynamicPFont = styled.p<{
  weight: number | string;
  size: number | string;
  $lHeight: number | string;

  $weightMd?: number | string;
  $sizeMd?: number | string;
  $lHeightMd?: number | string;

  $weightLg?: number | string;
  $sizeLg?: number | string;
  $lHeightLg?: number | string;
}>`
  ${defaultFont}
  font-weight: ${({ weight }) => weight || 300};
  font-size: ${({ size }) => size || '16px'};
  line-height: ${({ $lHeight }) => $lHeight || '24px'};

  @media ${mqSmallMin} {
    font-weight: ${({ $weightMd }) => $weightMd || 350};
    font-size: ${({ $sizeMd }) => $sizeMd || '16px'};
    line-height: ${({ $lHeightMd }) => $lHeightMd || '24px'};
  }

  @media ${mqLargeMin} {
    font-weight: ${({ $weightLg }) => $weightLg || 400};
    font-size: ${({ $sizeLg }) => $sizeLg || '16px'};
    line-height: ${({ $lHeightLg }) => $lHeightLg || '24px'};
  }
`;

export const DynamicPageHeader = styled.h1<{
  weight?: number | string;
  size?: number | string;
  lHeight?: number | string;
  children?:
    | React.ReactNode
    | JSX.Element
    | JSX.Element[]
    | (() => JSX.Element);
}>`
  ${defaultFont}
  font-weight: ${(props) => props.weight || 300};
  font-size: ${(props) => props.size || 70}px;
  line-height: ${(props) => `${props.lHeight}px` || 1.2};
`;

export const ATag = styled.a<{
  textDecoration?: string;
  size?: number;
  onClick?: () => void;
  children?:
    | React.ReactNode
    | JSX.Element
    | JSX.Element[]
    | (() => JSX.Element);
}>`
  font-size: ${(props) => props.size || 13}px;
  text-decoration: ${(props) => props.textDecoration || 'underline'};
`;
